<template #default>
  <div class="page-view">
    <a-card class="page-filter" :bordered="false">
      <a-form layout="inline" @submit.prevent="onSearch">
        <a-form-item label="Account">
          <a-input
            v-model:value="accountCode"
            placeholder="Enter code..."
            @pressEnter="onSearch"
          />
        </a-form-item>
        <a-form-item label="Fund">
          <a-select
            v-model:value="selectedFundCode"
            style="width: 260px"
            allow-clear
            show-search
            placeholder="All"
            :filter-option="filterOption"
          >
            <a-select-option
              v-for="item in fundList"
              :key="item.fundCode"
              :value="item.fundCode"
            >
              {{ item.fundCode }} - {{ item.fundDesc }}
            </a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item label="Broker">
          <a-select
            v-model:value="selectedBrokerCode"
            placeholder="All"
            style="width: 220px"
            allow-clear
            show-search
            :filter-option="filterOption"
          >
            <a-select-option
              v-for="item in brokerList"
              :key="item.brokerCode"
              :value="item.brokerCode"
            >
              {{ item.brokerCode }}
            </a-select-option>
          </a-select>
        </a-form-item>
        <!-- <a-form-item label="AccountType">
          <a-select
            v-model:value="selectedAccountType"
            placeholder="All"
            style="width: 160px"
            allow-clear
            show-search
            :filter-option="filterOption"
          >
            <a-select-option
              v-for="item in accountTypeList"
              :key="item.code"
              :value="item.code"
            >
              {{ item.desc }}
            </a-select-option>
          </a-select>
        </a-form-item> -->
        <a-form-item label="Status">
          <a-select
            v-model:value="active"
            style="width: 120px"
            allow-clear
            placeholder="All"
          >
            <a-select-option value="true">Active</a-select-option>
            <a-select-option value="false">InActive</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item>
          <div class="page-actions">
            <a-button type="primary" @click="onSearch" :loading="loading">
              Search
            </a-button>
            <a-button v-if="isAdminOrItRole" @click="showAddModal">
              Add
            </a-button>
          </div>
        </a-form-item>
      </a-form>
    </a-card>

    <div class="page-grid page-grid--h360">
      <AgGridVue
        style="width: 100%; height: 100%"
        :theme="themeBalham"
        :loading="loading"
        :columnDefs="columnDefs"
        :defaultColDef="defaultColDef"
        :rowData="rowData"
        :gridOptions="gridOptions"
        :getRowId="getRowId"
      />
    </div>

    <a-modal
      class="page-modal"
      v-model:visible="addModalVisible"
      :title="isEdit ? 'Edit Broker Account' : 'Add Broker Account'"
      @ok="isEdit ? handleEditBrokerAccount() : handleAddBrokerAccount()"
      @cancel="handleAddCancel"
      :confirmLoading="addLoading"
      destroyOnClose
    >
      <a-form
        :model="addForm"
        :label-col="{ span: 6 }"
        :wrapper-col="{ span: 16 }"
        layout="horizontal"
      >
        <a-form-item label="Account Code" required>
          <a-input
            v-model:value="addForm.accountCode"
            placeholder="Enter account code"
            :disabled="isEdit"
            @input="onAccountCodeInput"
          />
        </a-form-item>
        <a-form-item label="Account Desc">
          <a-input
            v-model:value="addForm.accountDesc"
            placeholder="Enter account description"
          />
        </a-form-item>
        <a-form-item label="Fund" required>
          <a-select
            v-if="isEdit"
            v-model:value="addForm.fundIdList"
            mode="multiple"
            placeholder="Select funds"
            style="width: 100%"
            show-search
            :filter-option="filterOption"
          >
            <a-select-option
              v-for="item in allFundList"
              :key="item.fundCode"
              :value="item.fundId"
            >
              {{ item.fundCode }} - {{ item.fundDesc }}
            </a-select-option>
          </a-select>
          <div
            v-if="isEdit && selectedFundLabels.length"
            style="
              margin-top: 8px;
              color: rgba(0, 0, 0, 0.65);
              line-height: 1.5;
            "
          >
            {{ selectedFundLabels.join(', ') }}
          </div>
          <a-select
            v-else
            v-model:value="addForm.fundIdList"
            mode="multiple"
            placeholder="Select funds"
            style="width: 100%"
            show-search
            :filter-option="filterOption"
          >
            <a-select-option
              v-for="item in fundList"
              :key="item.fundCode"
              :value="item.fundId"
            >
              {{ item.fundCode }} - {{ item.fundDesc }}
            </a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item label="Broker" required>
          <a-select
            v-model:value="addForm.brokerId"
            placeholder="Select broker"
            style="width: 100%"
            show-search
            :filter-option="filterOption"
            :disabled="isEdit"
          >
            <a-select-option
              v-for="item in brokerList"
              :key="item.brokerCode"
              :value="item.brokerId"
            >
              {{ item.brokerCode }}
            </a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item label="AccountType" required>
          <a-select
            v-model:value="addForm.accountType"
            placeholder="Select type"
            :show-search="true"
            :filter-option="filterOption"
          >
            <a-select-option
              v-for="item in accountTypeList"
              :key="item.desc"
              :value="item.code"
            >
              {{ item.desc }}
            </a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item label="PnlEngineType">
          <a-select
            v-model:value="addForm.pnlEngineType"
            placeholder="Select PnlEngineType"
            :show-search="true"
            :filter-option="filterOption"
          >
            <a-select-option
              v-for="item in pnlEngineTypeList"
              :key="item.desc"
              :value="item.code"
            >
              {{ item.desc }}
            </a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item label="HandInst">
          <a-input
            v-model:value="addForm.handInst"
            placeholder="Enter hand inst"
          />
        </a-form-item>
        <a-form-item label="Market">
          <a-input v-model:value="addForm.market" placeholder="Enter market" />
        </a-form-item>
        <a-form-item label="IsActive">
          <a-select
            v-model:value="addForm.isActive"
            placeholder="Select status"
            style="width: 120px"
          >
            <a-select-option value="true">Active</a-select-option>
            <a-select-option value="false">InActive</a-select-option>
          </a-select>
        </a-form-item>
      </a-form>
    </a-modal>
  </div>
</template>

<script setup>
import { ref, computed, onMounted, defineExpose } from 'vue'
import { useStore } from 'vuex'
import { themeBalham } from 'ag-grid-community'
import { message } from 'ant-design-vue'

import brokerAccount from '@/api/brokerAccount'
import organization from '@/api/organization'
import brokerAccountViewColumnDefs from './BrokerAccountView_ColumnDefs'
import AgEditCellRenderer from '@/components/AgEditCellRenderer.vue'

const store = useStore()

const defaultColDef = {
  filter: true,
  sortable: true,
  resizable: true,
  enableCellChangeFlash: true,
}

defineExpose({
  AgEditCellRenderer,
})

const selectedFundCode = ref(undefined)
const selectedBrokerCode = ref(undefined)
const selectedAccountType = ref(undefined)
const active = ref(undefined)
const accountCode = ref('')
const loading = ref(false)
const rowData = ref([])
const gridApi = ref(null)

const getErrorMessage = (error, fallback) =>
  error?.response?.data?.message || fallback

const gridOptions = ref({
  suppressScrollOnNewData: true,
  onGridReady: (params) => {
    gridApi.value = params.api
  },
})

const getRowId = (params) => String(params?.data?.accountId ?? '')

const isAdminOrItRole = computed(() => {
  const roles = store.getters['auth/getRoleList'] || []
  const roleNames = [...roles].map((r) => r.name)
  return roleNames.includes('SRM_Admin') || roleNames.includes('SRM_IT')
})

const fundList = computed(() => {
  const funds = store.getters['reference/getFundList'] || []
  return [...funds]
    .filter((f) => f.isActive && f.isReal)
    .sort((a, b) => a.fundCode.localeCompare(b.fundCode))
})

const allFundList = computed(() => {
  const funds = store.getters['reference/getFundList'] || []
  return [...funds].sort((a, b) => a.fundCode.localeCompare(b.fundCode))
})

const brokerList = ref([])

const accountTypeList = computed(() => [
  {
    code: 'NONE',
    desc: 'NONE',
  },
])

const pnlEngineTypeList = computed(() => [
  {
    code: '',
    desc: 'None',
  },
  {
    code: 'FourSides',
    desc: 'FourSides',
  },
])

const addModalVisible = ref(false)
const addLoading = ref(false)

const createEmptyForm = () => ({
  accountCode: '',
  accountDesc: '',
  brokerId: null,
  fundId: null,
  fundIdList: [],
  accountType: 'NONE',
  pnlEngineType: '',
  handInst: '',
  market: '',
  isActive: 'true',
})

const addForm = ref(createEmptyForm())
const isEdit = ref(false)

const filterOption = (input, option) =>
  option.key.toLowerCase().includes(input.toLowerCase())

const getActiveValue = () => {
  if (active.value === 'true') return true
  if (active.value === 'false') return false
  return undefined
}

const normalizeFundId = (value) => {
  if (value === null || value === undefined || value === '') {
    return null
  }
  const fundId = Number(value)
  return Number.isNaN(fundId) ? value : fundId
}

const normalizeFundIdList = (data) => {
  if (Array.isArray(data?.fundIdList)) {
    return data.fundIdList
      .map((fundId) => normalizeFundId(fundId))
      .filter((fundId) => fundId !== null)
  }
  if (data?.fundId != null) {
    return [normalizeFundId(data.fundId)].filter((fundId) => fundId !== null)
  }
  return []
}

const selectedFundLabels = computed(() => {
  if (!isEdit.value || !Array.isArray(addForm.value.fundIdList)) {
    return []
  }

  const selectedFundIdSet = new Set(
    addForm.value.fundIdList
      .map((fundId) => normalizeFundId(fundId))
      .filter((fundId) => fundId !== null)
  )

  return allFundList.value
    .filter((fund) => selectedFundIdSet.has(normalizeFundId(fund.fundId)))
    .map((fund) => `${fund.fundCode} - ${fund.fundDesc}`)
})

const onSearch = async () => {
  loading.value = true
  try {
    const qry = {
      accountCode: accountCode.value.trim() || null,
      fundCode: selectedFundCode.value,
      brokerCode: selectedBrokerCode.value || null,
      accountType: selectedAccountType.value,
      isActive: getActiveValue(),
    }
    const resp = await brokerAccount.getBrokerAccounts(qry)
    const data = resp.data
    rowData.value = Array.isArray(data) ? data : []
    if (rowData.value.length === 0) {
      message.info('No data found.')
    }
  } catch (e) {
    message.error(getErrorMessage(e, 'Query failed'))
  } finally {
    loading.value = false
  }
}

const showAddModal = () => {
  isEdit.value = false
  addForm.value = createEmptyForm()
  addModalVisible.value = true
}

const showEditModal = (event) => {
  const data = event?.data || event
  isEdit.value = true
  addForm.value = {
    ...data,
    fundIdList: normalizeFundIdList(data),
    pnlEngineType: data?.pnlEngineType ?? '',
    isActive: String(data?.isActive ?? true),
  }
  addModalVisible.value = true
}

const handleAddCancel = () => {
  addModalVisible.value = false
}

const validateForm = () => {
  const hasFundSelection =
    Array.isArray(addForm.value.fundIdList) &&
    addForm.value.fundIdList.length > 0

  if (!addForm.value.accountCode || !hasFundSelection) {
    message.warning('Please fill all required fields.')
    return false
  }
  if (!addForm.value.brokerId || !addForm.value.accountType) {
    message.warning('Please fill all required fields.')
    return false
  }
  return true
}

const handleAddBrokerAccount = async () => {
  if (!validateForm()) return
  addLoading.value = true
  try {
    const payload = {
      ...addForm.value,
      isActive: addForm.value.isActive === 'true',
      fundCode: null,
    }
    const broker = brokerList.value.find((b) => b.brokerId === payload.brokerId)
    if (broker) {
      payload.brokerCode = broker.brokerCode
    }
    await brokerAccount.createBrokerAccount(payload)
    message.success('Add success')
    addModalVisible.value = false
    onSearch()
  } catch (e) {
    message.error(getErrorMessage(e, 'Add failed'))
  } finally {
    addLoading.value = false
  }
}

const handleEditBrokerAccount = async () => {
  if (!validateForm()) return
  addLoading.value = true
  try {
    const payload = {
      ...addForm.value,
      isActive: addForm.value.isActive === 'true',
      fundCode: null,
      brokerCode: null,
    }
    await brokerAccount.updateBrokerAccount(payload)
    await onSearch()
    message.success('Edit success')
    addModalVisible.value = false
  } catch (e) {
    message.error(getErrorMessage(e, 'Edit failed'))
  } finally {
    addLoading.value = false
  }
}

const columnDefs = brokerAccountViewColumnDefs.map((col) => {
  if (col.field === 'edit') {
    return {
      ...col,
      cellRendererParams: {
        showEditModal: (data) => showEditModal(data),
      },
    }
  }
  return col
})

const onAccountCodeInput = (event) => {
  const value = event?.target?.value || ''
  addForm.value.accountCode = value.toUpperCase()
}

onMounted(async () => {
  try {
    const brokerResp = await organization.getOrganizations({
      organizationCode: null,
      organizationTypeCode: 'COUNTERPARTY',
      statusCode: 'A',
    })
    brokerList.value =
      brokerResp.data
        .filter(
          (r) =>
            r.organizationCode !== 'ANY ORGANISATION' &&
            !r.organizationCode.includes('TEST')
        )
        .map((r) => ({
          brokerId: r.organizationId,
          brokerCode: r.organizationCode,
        }))
        .sort((a, b) => a.brokerCode.localeCompare(b.brokerCode)) || []
  } catch (e) {
    message.error(getErrorMessage(e, 'Failed to fetch reference lists'))
  }
})
</script>
